export default __webpack_public_path__ + "static/media/ugi_logo_outer.d10349e9.svg";